module.exports = __webpack_public_path__ + "img/compass.bac0faa1.svg";